import { IRequestResult } from "../api-client";
import { BaseApi } from "../base";

export class ApplicationSettingsApi extends BaseApi {
  protected readonly prefix = "applicationSettings";

  fetch = (): Promise<IRequestResult<unknown>> => this.get("");
}
